export default __webpack_public_path__ + "static/media/FuturaPTBook.bc305be0.otf";